import React from 'react';
import './normalPages.scss'

const LegalNotice = () => {
    return (
        <>
            <div className="normal_page">
                <h1>LEGAL NOTICEe</h1>

                <div className="content">
                    <h2>Legal Credits</h2>
                    <p>Concept and production:  <br /><br />
                        This Online store was created using Prestashop Shopping Cart Software,check out PrestaShop's ecommerce blog for news and advices about selling online and running your ecommerce website.    <br /><br />
                        Boxes are amply sized and your items are well-protected.</p>
                </div>


            </div>
        </>
    );
};

export default LegalNotice;